import { ethers } from "ethers";
import { WALLETTOOL, SwapABI, QuoterV2, PancakeV3Factory, MainTokenConfig, RouterConfig, PancakeRouterABI, PancakeFactoryABI, Flap, poolManagerABI, zeroAddress } from "@/config";
import { isAddress } from "@/utils";
import { makeRequest } from "../req";
import { v4PriceConfigChange } from "@/store";
import { formatUnits, getContract, parseAbi, parseUnits } from "viem";
import { to0xString } from "./toHex";
import BigNumber from 'bignumber.js'


// ✅ 普通函数
export async function getPrice(
  provider: any,
  _token: any,
  _spenToken: any,
  _router: any,
  _chainId: number,
  _feeV3: number,
  _v3Factory: string,
  _swapType: string,
  dispatch: any,
) {

  let pairAddress = "";
  let WETHToken = "";
  let price = "0";
  // try {
  let result: { price: string; pairAddress: string; WETHToken: string; arr: any[] }
  switch (_swapType) {
    case 'V4':
      result = await getV4Price();
      break;
    case 'V3':
      result = await getV3Price();
      break;
    case 'V2':
      result = await getV2Price();
      break;
    case 'four':
      result = await getFourPrice();
      break;
    case 'flap':
      result = await getFlapPrice();
      break;
    default:
      result = await getV2Price();
      break;
  }
  return result;

  // ---------------- V2 ----------------
  async function getV2Price() {
    if (!isAddress(_token?.address) ||
      !isAddress(_spenToken?.address) ||
      !isAddress(_router.address) ||
      !WALLETTOOL[_chainId]) return { price: "0", pairAddress: "", WETHToken: "", arr: [] };

    const contract = getContract({
      address: to0xString(_router.address),
      abi: PancakeRouterABI,
      client: provider
    });
    console.log('_router::: ', _router);
    const amountIn = (10 ** _token.decimals).toString();
    const path1 = [_token?.address, _spenToken?.address];
    // 当spendToken是主币的时候显示U价格
    const path2 = [_token?.address, _spenToken?.address, MainTokenConfig[_chainId][1]?.address || ""];
    let isSpecialPath
    isSpecialPath = MainTokenConfig[_chainId][0].address.toLowerCase() == _spenToken?.address.toLowerCase();
    if (_chainId === 5042) isSpecialPath = false
    const path = isSpecialPath ? path2 : path1;

    // 使用 multicall 批量请求
    const multicallResult = await provider.multicall({
      contracts: [
        {
          ...contract,
          functionName: 'getAmountsOut',
          args: [amountIn, path]
        },
        {
          ...contract,
          functionName: 'factory'
        }
      ],
      multicallAddress: '0xca11bde05977b3631167028862be2a173976ca11'
    });

    // 解析结果
    const [amountsResult, factoryAddress] = multicallResult;

    if (amountsResult.status === 'failure') {
      throw new Error('getAmountsOut failed');
    }

    // 获取价格
    const amounts = amountsResult.result;
    if (isSpecialPath) {
      price = formatUnits(amounts[2], MainTokenConfig[_chainId][1].decimals)
    } else {
      price = formatUnits(amounts[1], _spenToken?.decimals)
    }

    const factoryContract = getContract({
      address: factoryAddress.result,
      abi: PancakeFactoryABI,
      client: provider
    }) as any

    pairAddress = await factoryContract.read.getPair([_token?.address, _spenToken?.address]);

    WETHToken = MainTokenConfig[_chainId]?.[0]?.address ??
      "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";

    return { price, pairAddress, WETHToken, arr: [] };
  }


  // ---------------- V3 ----------------
  async function getV3Price() {
    const v3FactoryContract = getContract({
      address: to0xString(_v3Factory),
      abi: PancakeV3Factory,
      client: provider
    }) as any

    const fee = Number(_feeV3) * 10000;
    // console.log(_v3Factory)

    const poolAddress = await v3FactoryContract.read.getPool([
      _token.address,
      _spenToken.address,
      fee
    ]);

    pairAddress = poolAddress;
    console.log(pairAddress)
    if (!isAddress(poolAddress) && poolAddress === zeroAddress) return { price: "0", pairAddress: "", WETHToken: "", arr: [] };




    // ✅ 定义 Interface
    const PANCAKE_V3_POOL_ABI = parseAbi([
      'function slot0() view returns (uint160 sqrtPriceX96, int24 tick, uint16 observationIndex, uint16 observationCardinality, uint16 observationCardinalityNext, uint8 feeProtocol, bool unlocked)',
      'function token0() external view returns (address)',
      'function token1() external view returns (address)'
    ])


    // ✅ 使用 multicall 一次性获取所有数据
    const multicallResult = await provider.multicall({
      contracts: [
        {
          address: poolAddress,
          abi: PANCAKE_V3_POOL_ABI,
          functionName: 'slot0',
          args: []
        },
        {
          address: poolAddress,
          abi: PANCAKE_V3_POOL_ABI,
          functionName: 'token0',
          args: []
        }
      ],
      multicallAddress: '0xca11bde05977b3631167028862be2a173976ca11'
    })
    console.log('multicallResult::: ', multicallResult);

    const slot0Result = multicallResult[0].result;
    const token0Result = multicallResult[1].result;

    const sqrtPriceX96 = new BigNumber(slot0Result[0].toString())
    BigNumber.config({ DECIMAL_PLACES: 60 })
    console.log(sqrtPriceX96.toString())
    const Q96 = new BigNumber(2).pow(96)
    const basePrice = sqrtPriceX96.div(Q96).pow(2)
    console.log('basePrice::: ', basePrice.toString());
    const token0Address = token0Result.toLowerCase();
    const tokenAddress = _token.address.toLowerCase();

    // V3 slot0 的 basePrice 是 token1 / token0
    // 最终统一计算成：_token / _spenToken
    let priceBN: BigNumber;

    if (token0Address === tokenAddress) {
      // token0 = _token
      // token1 = _spenToken
      priceBN = basePrice.multipliedBy(
        new BigNumber(10).pow(
          _token.decimals - _spenToken.decimals
        )
      );
    } else {
      // token0 = _spenToken
      // token1 = _token
      // 所以需要取倒数
      priceBN = new BigNumber(1)
        .div(basePrice)
        .multipliedBy(
          new BigNumber(10).pow(
            _token.decimals - _spenToken.decimals
          )
        );
    }
    price = priceBN.toFixed(18).replace(/\.?0+$/, "")
    console.log('price::: ', price);

    if (token0Result.toLowerCase() == _spenToken?.address.toLowerCase()) {//如果token0等于花费代币,那么该价格等于花费代币价格，需要换算

      console.log('MainTokenConfig[_chainId][0].address.toLowerCase() == _spenToken?.address.toLowerCase()::: ', MainTokenConfig[_chainId][0].address.toLowerCase(), _spenToken?.address.toLowerCase());
      if (MainTokenConfig[_chainId][0].address.toLowerCase() == _spenToken?.address.toLowerCase()) {
        console.log('11111::: ', 11111);
        const contract = getContract({
          address: to0xString(RouterConfig[_chainId][0].address),
          abi: PancakeRouterABI,
          client: provider
        }) as any
        const prices = (await contract.read.getAmountsOut([parseUnits(price, _spenToken.decimals), [_spenToken?.address, MainTokenConfig[_chainId][1].address]]))[1];
        console.log('price::: ', price);
        price = formatUnits(prices, MainTokenConfig[_chainId][1].decimals).toString();
      } else {
        price = Number(price).toFixed(_spenToken.decimals)
        console.log('price::: ', price);
      }
    } else {
      if (MainTokenConfig[_chainId][0].address.toLowerCase() == _spenToken?.address.toLowerCase()) {
        const contract = getContract({
          address: to0xString(RouterConfig[_chainId][0].address),
          abi: PancakeRouterABI,
          client: provider
        }) as any
        price = ethers.utils.parseUnits(price, 18).toString();
        price = (await contract.read.getAmountsOut([price, [_spenToken?.address, MainTokenConfig[_chainId][1].address]]))[1];
        price = ethers.utils.formatUnits(price, MainTokenConfig[_chainId][1].decimals).toString();
      }

    }


    WETHToken = MainTokenConfig[_chainId]?.[0]?.address ??
      "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";

    return { price, pairAddress, WETHToken, arr: [] };
  }

  // ---------------- Springboard ----------------
  async function getFourPrice() {
    // const swapContract = new ethers.Contract("0x5c952063c7fc8610FFDB798152D69F0B9550762b", SwapABI, provider);
    const swapContract = getContract({
      address: to0xString('0x5c952063c7fc8610FFDB798152D69F0B9550762b'),
      abi: SwapABI,
      client: provider
    }) as any
    const info = await swapContract.read._tokenInfos([_token?.address]);
    console.log('info::: ', info);

    //转换底池价格
    if (MainTokenConfig[_chainId][0].address.toLowerCase() == _spenToken?.address.toLowerCase()) {
      // const contract = new ethers.Contract(RouterConfig[_chainId][0].address, PancakeRouterABI, provider);
      const contract = getContract({
        address: to0xString(RouterConfig[_chainId][0].address),
        abi: PancakeRouterABI,
        client: provider
      }) as any
      const ss: bigint = (await contract.read.getAmountsOut([info[9], [_spenToken?.address, MainTokenConfig[_chainId][1].address]]))[1];
      console.log('ss::: ', ss);
      price = formatUnits(ss, MainTokenConfig[_chainId][1].decimals)
    } else {
      price = formatUnits(info[9], _spenToken.decimals)
    }
    pairAddress = "0x5c952063c7fc8610FFDB798152D69F0B9550762b";
    WETHToken =
      MainTokenConfig[_chainId]?.[0]?.address ??
      "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";

    return { price, pairAddress, WETHToken, arr: [] };
  }
  async function getFlapPrice() {
    // const swapContract = new ethers.Contract(RouterConfig[_chainId as keyof typeof RouterConfig]?.find(item => item.label === "flap")?.address, Flap, provider);

    const swapContract = getContract({
      address: to0xString(RouterConfig[_chainId as keyof typeof RouterConfig]?.find(item => item.label === "flap")?.address),
      abi: Flap,
      client: provider
    }) as any

    const info = await swapContract.read.calculateOutput([_token?.address, _spenToken?.address, (1 * 10 ** _token?.decimals).toString()]);

    //转换底池价格
    if (MainTokenConfig[_chainId][0].address.toLowerCase() == _spenToken?.address.toLowerCase()) {
      // const contract = new ethers.Contract(RouterConfig[_chainId][0].address, PancakeRouterABI, provider);
      const contract = getContract({
        address: to0xString(RouterConfig[_chainId][0].address),
        abi: PancakeRouterABI,
        client: provider
      }) as any
      price = (await contract.read.getAmountsOut([info, [_spenToken?.address, MainTokenConfig[_chainId][1].address]]))[1];
      price = formatUnits(BigInt(price), MainTokenConfig[_chainId][1].decimals);
    } else {
      price = formatUnits(BigInt(info), _spenToken.decimals);
    }
    pairAddress = RouterConfig[_chainId as keyof typeof RouterConfig]?.find(item => item.label === "flap")?.address;

    WETHToken =
      MainTokenConfig[_chainId]?.[0]?.address ??
      "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";

    return { price, pairAddress, WETHToken, arr: [] };
  }
  async function getV4Price() {

    const address1 = _spenToken.address.toLowerCase();
    // console.log('_spenToken.address::: ', _spenToken.address);
    const address2 = _token.address.toLowerCase();

    // 按字符串字典序排序，赋值给 tokenA 和 tokenB
    const [tokenA, tokenB] = [address1, address2].sort();
    console.log('tokenA, tokenB::: ', tokenA, tokenB);
    const res = JSON.stringify([address1, address2]) === JSON.stringify([tokenA, tokenB]);
    const queryBody = {
      "query": `query Subgraphs { pools(where: { token0: \"${tokenA}\", token1: \"${tokenB}\" }) { id token0Price token1Price  feeTier  hooks volumeUSD tick token0 { name symbol } token1 { name symbol } } }`,
      "operationName": "Subgraphs",
      "variables": {}
    }
    // console.log(queryBody, 'queryBody');
    const result = await makeRequest(
      `/subgraph/get?chain_id=${_chainId}`,
      "POST",
      {},
      queryBody
    );

    WETHToken = MainTokenConfig[_chainId]?.[0]?.address ??
      "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";

    const pools = result.data.pools;

    // 用 reduce 找出 volumeUSD 最大的那一条
    const maxVolumePool = pools.reduce((max, current) => {
      // 把字符串转成数字再比较
      const currentVolume = parseFloat(current.volumeUSD);
      const maxVolume = parseFloat(max.volumeUSD);
      return currentVolume > maxVolume ? current : max;
    }, pools[0]); // 初始值设为数组第一个元素
    dispatch(v4PriceConfigChange(maxVolumePool))
    console.log('maxVolumePool::: ', maxVolumePool);
    // const poolManager = new ethers.Contract(_v3Factory, poolManagerABI, provider);
    const poolManager = getContract({
      address: to0xString(_v3Factory),
      abi: poolManagerABI,
      client: provider
    }) as any
    const poolKeyArray = await poolManager.read.poolIdToPoolKey([maxVolumePool.id]);
    console.log('poolKeyArray::: ', poolKeyArray);

    return { price: Number(res ? maxVolumePool.token0Price : maxVolumePool.token1Price).toFixed(10), pairAddress: maxVolumePool.id, WETHToken, arr: poolKeyArray };

  }
}


